const states = {
  auth: (state: any) => state.auth
};

export default states;
